/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectIndicator_project = {
    readonly name: string | null;
    readonly companyProjectId: number | null;
    readonly customProjectId: string | null;
    readonly projectColor: string | null;
    readonly " $refType": "ProjectIndicator_project";
};
export type ProjectIndicator_project$data = ProjectIndicator_project;
export type ProjectIndicator_project$key = {
    readonly " $data"?: ProjectIndicator_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProjectIndicator_project">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectIndicator_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColor",
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
(node as any).hash = 'c4adcd44ebb212f53d9cb6d6ef78adb2';
export default node;
